import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AddTimesheetForm from './AddTimesheetForm';
import TimesheetList from './TimesheetList';
import Modal from './Model'; // Import the modal component
import EditTimesheet from './EditTimesheet'; // Import EditTimesheet component
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function TimesheetPage() {
  const [entries, setEntries] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null); // To store the selected entry
  const navigate = useNavigate();

  const fetchEntries = async () => {
    const token = localStorage.getItem("token");
    try {

    const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/timesheets`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    setEntries(res.data);
  } catch (err) {
    console.error("Error fetching hearings:", err);
  }
  };
  const handleDelete = async (id) => {
    const token = localStorage.getItem("token");
    await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/timesheets/${id}`,{
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
        toast.success("Timesheet deleted successfully!");
    fetchEntries();
  };

  const handleEdit = (entry) => {
    setSelectedEntry(entry); // Set the selected entry to pass to the modal
    setIsModalOpen(true); // Open the modal
  };


  // Callback to close modal and clear selected entry
  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedEntry(null);
  };

  // Callback to refresh entries after edit
  const handleEntryUpdated = () => {
    fetchEntries();
    closeModal();
  };

  useEffect(() => {
    fetchEntries();
  }, []);

  return (
    <div className="p-6 space-y-6">
        <ToastContainer position="top-right" autoClose={3000} />
      <h1 className="text-2xl font-bold text-white">Timesheet Management</h1>
      <AddTimesheetForm onTimesheetAdded={fetchEntries} />
      <TimesheetList
        entries={entries}
        onDelete={handleDelete}
        onEdit={handleEdit} // Passing handleEdit to open modal
      />

      {/* Modal to edit timesheet */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <EditTimesheet entry={selectedEntry} onClose={closeModal} onUpdated={handleEntryUpdated} />
      </Modal>
    </div>
  );
}

export default TimesheetPage;
